// Helpers compartidos del panel OAuth (Conectar ChatGPT).
import { toast } from 'sonner';
import { Button } from '../../../components/ui/button';
import { Copy } from 'lucide-react';

export const copiar = (texto, label) => {
  navigator.clipboard.writeText(texto);
  toast.success(`${label} copiado`);
};

// dd-mm-yyyy HH:MM (hora local, 24 h)
export const fmtFechaHora = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export function CopiaRow({ label, valor, testid, mono = true }) {
  return (
    <div className="flex items-center gap-2 rounded-lg border bg-slate-50 px-3 py-2" data-testid={testid}>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-medium text-muted-foreground">{label}</p>
        <p className={`truncate text-xs ${mono ? 'font-mono' : ''}`}>{valor}</p>
      </div>
      <Button variant="ghost" size="sm" onClick={() => copiar(valor, label)} data-testid={`${testid}-copy`}>
        <Copy className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
